import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { UIRouterModule } from '@uirouter/angular';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { ComponentsModule } from '../components/components.module';
import { RvSortableModule } from '../rv-sortable/rv-sortable.module';
import { SharedModule } from '../shared/shared.module';
import { routes } from './schedules.routes';

import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AccessibilityModule } from '../accessibility';
import { ApiModule } from '../api/api.module';
import { ArrowKeyNavigationModule } from '../components/arrow-key-navigation/arrow-key-navigation.module';
import { FolderPathComponent } from '../components/folders/folder-path/folder-path.component';
import { NewFolderButtonComponent } from '../components/folders/new-folder-button/new-folder-button.component';
import { NoResultsComponent } from '../components/no-results/no-results.component';
import { OperationsMenuComponent } from '../components/operations-menu/operations-menu.component';
import { RvBadgeComponent } from '../components/rv-badge/rv-badge.component';
import { ScheduleTypePillComponent } from '../components/schedule-type-pill/schedule-type-pill.component';
import { UrlFieldComponent } from '../components/url-field/url-field.component';
import { PresentationsModule } from '../presentations/presentations.module';
import { RvDraggableModule } from '../rv-draggable/rv-draggable.module';
import { UsernamePipe } from '../shared/pipes/username.pipe';
import { AddToScheduleModalComponent } from './components/add-to-schedule-modal/add-to-schedule-modal.component';
import { PlaylistItemComponent } from './components/playlist-item/playlist-item.component';
import { PlaylistComponent } from './components/playlist/playlist.component';
import { PreviewSelectorComponent } from './components/preview-selector/preview-selector.component';
import { ScheduleAddComponent } from './components/schedule-add/schedule-add.component';
import { ScheduleDetailsComponent } from './components/schedule-details/schedule-details.component';
import { ScheduleFieldsComponent } from './components/schedule-fields/schedule-fields.component';
import { ScheduleListComponent } from './components/schedule-list/schedule-list.component';
import { SchedulePickerModalComponent } from './components/schedule-picker-modal/schedule-picker-modal.component';
import { ScheduleSelectorComponent } from './components/schedule-selector/schedule-selector.component';
import { ScheduleTypeSelectorComponent } from './components/schedule-type-selector/schedule-type-selector.component';
import { ShareScheduleButtonComponent } from './components/share-schedule-button/share-schedule-button.component';
import { SharedSchedulePopoverComponent } from './components/shared-schedule-popover/shared-schedule-popover.component';
import { provideScheduleFolderOperationService } from './providers/schedule-folder-operation.provider';
import { SchedulesViewportComponent } from './schedules-viewport/schedules-viewport.component';
import { NotificationAlertComponent } from '../components/notification-alert/notification-alert.component';
import { ScheduleService } from './services/schedule.service';
import { ActionLinkDirective } from '../accessibility/directives/action-link/action-link.directive';

@NgModule({
  declarations: [
    ScheduleSelectorComponent,
    ScheduleListComponent,
    PreviewSelectorComponent,
    SchedulePickerModalComponent,
    ScheduleTypeSelectorComponent,
    ScheduleAddComponent,
    ScheduleDetailsComponent,
    ScheduleFieldsComponent,
    PlaylistComponent,
    SchedulesViewportComponent,
    ShareScheduleButtonComponent,
    SharedSchedulePopoverComponent,
    AddToScheduleModalComponent,
    ScheduleSelectorComponent,
    PlaylistItemComponent,
  ],
  imports: [
    ActionLinkDirective,
    CommonModule,
    PresentationsModule,
    FormsModule,
    UIRouterModule.forChild(routes),
    ApiModule,
    ReactiveFormsModule,
    ComponentsModule,
    RvSortableModule,
    SharedModule,
    TooltipModule,
    PopoverModule,
    MatMenuModule,
    MatBottomSheetModule,
    MatCheckboxModule,
    MatTooltipModule,
    UrlFieldComponent,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatSelectModule,
    MatRadioModule,
    MatDialogModule,
    ScrollingModule,
    MatDividerModule,
    MatSlideToggleModule,
    AccessibilityModule,
    ScheduleTypePillComponent,
    NoResultsComponent,
    FolderPathComponent,
    NewFolderButtonComponent,
    OperationsMenuComponent,
    RvBadgeComponent,
    RvDraggableModule,
    ArrowKeyNavigationModule,
    NotificationAlertComponent,
  ],
  exports: [ScheduleSelectorComponent, PreviewSelectorComponent],
  providers: [
    UsernamePipe,
    { provide: 'HasFolderStructure', useClass: ScheduleService },
    provideScheduleFolderOperationService(),
  ],
})
export class SchedulesModule {}
